// src/modules/requerimiento/services/mantenimiento.js
import axios from "../../../config/axiosConfig";

export const postModemsByPlacas = (placas, config = {}) =>
  axios.post("/api/req-mantenimiento/placas/modems", { placas }, config);

export const getModemsByRequerimientoPlacas = (cod_req, config = {}) =>
  axios.get("/api/req-mantenimiento/placas/modems", {
    ...config,
    params: { ...(config.params || {}), cod_req },
  });

export const getMantenimientoAsignados = (cod) =>
  axios.get(`/api/req-mantenimiento/asignados/${encodeURIComponent(cod)}`);

export const postAsignarModems = (cod_req, num_sim, config = {}) =>
  axios.post(
    "/api/req-mantenimiento/asignar-modems",
    { cod_req, num_sim },
    config
  );

export const getMantenimientoDetalle = (cod_req, num_sim, config = {}) =>
  axios.get(
    `/api/req-mantenimiento/detalle/${encodeURIComponent(
      cod_req
    )}/${encodeURIComponent(num_sim)}`,
    config
  );

export const getFallasModem = (config = {}) =>
  axios.get("/api/req-mantenimiento/fallas/modem", config);

export const getModemsDisponibles = (config = {}) =>
  axios.get("/api/req-mantenimiento/modems/disponibles", config);

export const getChipsDisponibles = (config = {}) =>
  axios.get("/api/req-mantenimiento/chips/disponibles", config);

export const postReemplazoModem = (payload, config = {}) => {
  const fd = new FormData();
  fd.append("cod", payload.cod);
  fd.append("num_sim", payload.num_sim);
  fd.append("num_sim_sec", payload.num_sim_sec);
  if (payload.estado) fd.append("estado", payload.estado);
  if (payload.grupo) fd.append("grupo", payload.grupo);
  if (payload.alias) fd.append("alias", payload.alias);
  if (payload.transportista) fd.append("transportista", payload.transportista);
  if (payload.sociedad) fd.append("sociedad", payload.sociedad);
  if (payload.sucursal) fd.append("sucursal", payload.sucursal);
  if (payload.obs) fd.append("obs", payload.obs);
  if (payload.lugar) fd.append("lugar", payload.lugar);

  if (Array.isArray(payload.falla)) {
    payload.falla.forEach((f) => fd.append("falla[]", f));
  }

  // en tu código de reemplazo usabas imagen_{num_sim}
  if (payload.imagen) {
    if (payload.num_sim) {
      fd.append(`imagen_${payload.num_sim}`, payload.imagen);
    }
    if (payload.num_sim_sec) {
      fd.append(`imagen_${payload.num_sim_sec}`, payload.imagen);
    }
  }

  return axios.post("/api/req-mantenimiento/reemplazo-modem", fd, {
    ...config,
    headers: {
      ...(config.headers || {}),
      "Content-Type": "multipart/form-data",
    },
  });
};

export const postDevolucionModem = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/devolucion-modem", payload, config);

export const postReemplazoChip = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/reemplazo-chip", payload, config);

export const postAgregarChip = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/agregar-chip", payload, config);

export const postDevolucionChip = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/devolucion-chip", payload, config);

export const postRegistrarMantenimiento = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/registrar-mantenimiento", payload, config);

export const postFinalizarMantenimiento = (payload, config = {}) =>
  axios.post("/api/req-mantenimiento/finalizar-mantenimiento", payload, config);

export const getMantenimientoNotaPdf = (cod) =>
  axios.get(`/api/req-mantenimiento/${encodeURIComponent(cod)}/nota.pdf`, {
    responseType: "blob",
  });

/**
 * NUEVO: subir solo la imagen para un equipo ya asignado
 * espera: { cod, num_sim, imagen }
 * la mando igual que en reemplazo: imagen_{num_sim}
 */
export const postMantenimientoSubirImagen = ({ cod, num_sim, imagen }, config = {}) => {
  const fd = new FormData();
  fd.append("cod", cod);
  fd.append("num_sim", num_sim);

  // importantísimo: mismo nombre que backend espera
  if (imagen) {
    fd.append(`imagen_${num_sim}`, imagen);
  }

  return axios.post("/api/req-mantenimiento/subir-imagen", fd, {
    ...config,
    headers: {
      ...(config.headers || {}),
      "Content-Type": "multipart/form-data",
    },
  });
};
